import React from 'react'
import PropTypes from 'prop-types'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'

export default function AtlasButtonBar (props) {
  const {
    children
  } = props

  return (
    <AppBar position="static" style={{ backgroundColor: 'lightgrey', border: 'solid 1px grey', marginBottom: '10px', boxShadow: 'none' }}>
      <Toolbar>
        {children}
      </Toolbar>
    </AppBar>
  )
}

AtlasButtonBar.propTypes = {
  children: PropTypes.node
}
